import { State } from 'src/redux/reducers/RootReducer';
import { putUploadImage } from 'src/apis/UploadAPI';
import { REACT_APP_BUCKET_NAME } from 'src/environments/environment';
import { setAlert } from 'src/redux/actions/alertActions';
import { ALERT_TYPE } from 'src/constants/AlertType';
import { setFormStatus } from 'src/redux/actions/formActions';
import { FORM, FORM_STATUS } from 'src/constants/Form';
import { closeModal } from 'src/redux/actions/modalActions';
import { MODALS } from 'src/models/ModalModel';
import Debug from 'src/lib/Debug';

export const uploadFileAction:
(
  file: string,
  path:string,
  successmsg: string,
  errormsg: string,
  onUpload?: (path: string) => void,
) => ThunkedAction<State, boolean> =
  (
    file: string,
    path:string,
    successmsg: string,
    errormsg: string,
    onUpload?: (path: string) => void,
  ) => async (dispatch: any, getState: any) => {
    try {
      const organisation = getState().currentOrganisation.id;
      const payload = {
        path,
        file,
        bucket: REACT_APP_BUCKET_NAME,
      };
      dispatch(setFormStatus({ [FORM.upload_image]: FORM_STATUS.processing }));
      const response = await putUploadImage(organisation, payload);
      if (response.success) {
        if (onUpload) {
          onUpload(path);
        }
        dispatch(setAlert({
          type: ALERT_TYPE.success,
          message: successmsg,
        }));
        dispatch(closeModal({ modal: MODALS.uploadImage }));
        dispatch(setFormStatus({ [FORM.upload_image]: FORM_STATUS.success }));
        return true;
      }
      dispatch(setFormStatus({ [FORM.upload_image]: FORM_STATUS.error }));
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: errormsg,
      }));
      return false;
    } catch (e) { /* Log the error here */
      Debug.error(e);
      dispatch(setAlert({
        type: ALERT_TYPE.error,
        message: errormsg,
      }));
      return false;
    }
  };
//
